import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ValidUnit } from '../constants/units';

type Unit = ValidUnit | (string & {});

export default function WithUnit({ children, unit }: { children: React.ReactNode; unit: Unit }): JSX.Element {
    return (
        <React.Fragment>
            {children} <FormattedMessage id={`unit.${unit}`} defaultMessage={unit} />
        </React.Fragment>
    );
}
